// import function to register Swiper custom elements
import { register } from 'swiper/element/bundle';
// import { Navigation, Pagination } from 'swiper/modules';

// register Swiper custom elements
register();

// const swiperElements = document.querySelectorAll('swiper-container');
//
// const params = {
//   // array with CSS styles
//   injectStyles: [
//     `
//       .swiper {
//         overflow: var(--overflow-state);
//       }
//       `,
//   ],
//
//   // array with CSS urls
//   // injectStylesUrls: ['path/to/one.css', 'path/to/two.css'],
// };
//
// swiperElements.forEach((swiperElement) => {
//   Object.assign(swiperElement, params);
//
//   swiperElement.initialize();
// });
